<template>
  <v-app class="view">
    <div :style="{
                        paddingLeft:(drawer_width+12)+'px',
                        paddingRight:(12)+'px',

                     }"
         class="list-header">
      <v-row
          class="list-header-row">
        <v-col class="text-right">
          <!--itemHeight{{itemHeight}}-->
          <!--scrollY{{scrollY}}-->

          <!--startElementIndex{{startElementIndex}}-->


          เรียงตาม:
          <a :class="{active:sort==='name'}" href="#" @click="changeSort('name')">ชื่อ</a> &nbsp;
          <a :class="{active:sort==='total_price'}" href="#" @click="changeSort('total_price')">ราคา</a> &nbsp;

          <v-icon :class="{primary:display==='grid'}" large
                  @click="changeDisplay('grid')">mdi-view-grid
          </v-icon>
          <v-icon :class="{primary:display==='column2'}" large
                  @click="changeDisplay('column2')">mdi-format-columns
          </v-icon>
          <v-icon :class="{primary:display==='list'}" large
                  @click="changeDisplay('list')">mdi-format-align-justify
          </v-icon>


        </v-col>
      </v-row>
    </div>

    <v-content>

      <v-container
          :style="{
                        paddingLeft:(drawer_width)+'px',
                     }"
          class="fill-height container"
          fluid>


        <!--row,top  = floor(index/column)  -->
        <!--col,left  = index%column  -->
        <PromotionRow v-for="(promotion, index) in items"
                      :key="index"
                      :class="'display-'+display"
                      :currentIndex="-padItemOffset+startElementIndex+index-padItemAmount"
                      :display="display"
                      :promotion="promotion"
                      :style="{
                        left:((drawer_width+6)+((index%column_no)*column_width))+'px',
                        width: column_width+'px',
                        top:(Math.floor((-padItemOffset+startElementIndex+index-padItemAmount)/column_no)*itemHeight)+'px'
                     }"
                      class="pad-filter"
        >

        </PromotionRow>

        <LoadingDummy
            :itemHeight="itemHeight"
            :maxElementRender="maxElementRender"
            :scrollY="scrollY"
            :store="store">
        </LoadingDummy>


        <!--<div v-if="!$store.state.promotions.data || $store.state.promotions.data.length===0" v-for="n in 50">-->
        <!--</div>-->
        <!--<v-card-->

        <!--:style="{position:'absolute',top:(Math.max(50,$store.state.promotions.data.length)*itemHeight)+'px'}"-->
        <!--v-intersect="insssfiniteScrolling"></v-card>-->

        <!--<div v-if="!$store.state.promotions.response.links || $store.state.promotions.response.links.next"-->
        <!--v-for="n in 10">-->
        <!--<v-skeleton-loader-->
        <!--ref="skeleton"-->
        <!--type="actions"-->
        <!--:tile="true"-->
        <!--class="mx-auto"-->
        <!--&gt;</v-skeleton-loader>-->
        <!--</div>-->


      </v-container>
    </v-content>
    <v-navigation-drawer
        :width="drawer_width"
        class="nav"
        permanent
        touchless
    >
      <v-card class="pl-2 pt-2 pr-2 pb-2">
        <v-text-field v-model="filter_search_keyword"

                      class="search"
                      clearable
                      hide-details="true"
                      label="ค้นหา"
                      outlined
                      placeholder="ใส่คำค้นหา"
                      @click:clear="clear_reload()"
                      @keydown.enter="reload()"
        ></v-text-field>
      </v-card>
      <FilterCurrent :filter="store.filter" :setFilter="setFilter"></FilterCurrent>
      <v-btn v-if="[
                  UserConst.ROLE_ADMIN,
                  UserConst.ROLE_CEO,
                  UserConst.ROLE_DIRECTOR,
                  UserConst.ROLE_MANAGER,
                  UserConst.ROLE_ACCOUNT,
                  UserConst.ROLE_MARKETING].includes($store.state.$user.role)"
             absolute
             style="width: 150px;left: 50%;bottom: 75px;margin-left: -75px"
             class="primary" right :to="'/campaigns'">Edit Campaign</v-btn>
    </v-navigation-drawer>

  </v-app>
</template>
<style lang="scss" scoped>

a.active {
  font-weight: bold;
}

.view {
  font-size: 18px;
}

.nav {
  z-index: 1;
}

.container {
  position: relative;
  margin-top: 40px;
  min-width: 750px;
}

.pad-filter {
  padding: 16px 0 0 12px;
}

.search .v-input__control {
  /*height: 60px;*/
}

.list-header {
  position: fixed;
  top: 60px;
  z-index: 1;
  width: 100%;

}

.theme--light .list-header-row {
  background: #FFFFFF;
}

.theme--dark .list-header-row {
  background: #000000;
}

.display-grid {

}

.display-column2 {

}

</style>
<script lang="ts">
import {Promotion} from '@/models/Promotion'
import {Component} from 'vue-property-decorator'
import FilterCurrent from '../components/FilterCurrent.vue'
import LoadingDummy from '../components/LoadingDummy.vue'
import PromotionRow from '../components/Promotion/PromotionRow.vue'
import Helper from '../services/Helper.js'
import ListView from './ListView'
import { UserConst} from '@/models/User'

@Component({
  components: {FilterCurrent, LoadingDummy, PromotionRow},
})
export default class ViewPromotion extends ListView<Promotion> {
  // items: Promotion[] = []
  UserConst = UserConst
  store = this.$store.state.promotions

  drawer_ratio = 0.2

  commit_prefix = 'promotions'
  base_url = Helper.setting.promotion.getListAPI

  sort = 'id'

  display = 'column2'

  get column_no() {
    switch (this.display) {
      case 'list':
        return 1
      case 'column2':
        return 2
      case 'grid':
        return 4
    }
    return 1
  }

  get column_width() {
    return this.display_width / this.column_no
    // switch (this.display) {
    //   case 'list':
    //     return this.display_width/this.column_no;
    //   case 'column2':
    //     return 400
    //   case 'grid':
    //     return 200
    // }
  }

  mounted() {
    this.dateFrom = '';
    this.dateTo = '';
    //this.setFilter('promotion_type', 'S')
  }
}
</script>
<style lang="scss" scoped>
.view {

  .fill-height {
    padding-left: 150px;
  }
}

.nav {
  position: fixed;
  margin-top: 60px;

}
</style>
